import React from "react";
import { useParams } from "react-router-dom";
import ResourceDetail from "./Resource/ResourceDetail";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { useMeterDetail } from "../../hook";

export default function ResourceDetailLanding() {
  const { id } = useParams<{ id: string }>();
  const remoteUtilityId = useRemoteUtilityId();
  
  const { data: resource } = useMeterDetail(id, remoteUtilityId);

  return <ResourceDetail resource={resource} />;
}
